

const PaymentFailed = () => {
    return(
        <>
        Failed
        </>
    );
}

export default PaymentFailed;